//
//
//
//
//
//
//
//
//

export default {
  // name: 'xxxxxxxx',
  components: {
    //	xxxxxxxx
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {},
}



// WEBPACK FOOTER //
// ./src/pages/components/indexFooter.vue